export default "__VITE_ASSET__LspZnOxB__"